import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
  renderMultiPersonas,
  renderPersona,
} from 'components/EntityList'
import { MaintenanceArea } from 'gql.generated'
import { ConstrainMode, PersonaSize } from 'office-ui-fabric-react'
import { SelectionMode } from 'office-ui-fabric-react/lib/MarqueeSelection'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type MaintenanceListProps = EntityListProps<MaintenanceArea>

export const MaintenanceList: React.FC<MaintenanceListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        minWidth: 40,
        maxWidth: 40,
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('maintenanceArea', { minWidth: 75 }),
      fieldColumn('department', { minWidth: 75 }),
      fieldColumn('maintenanceHead', {
        onRender: renderMultiPersonas({ size: PersonaSize.size8 }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('modifiedBy', {
        onRender: renderPersona({ size: PersonaSize.size8 }),
        minWidth: 155,
        ungroupable: true,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.single}
      constrainMode={ConstrainMode.horizontalConstrained}
      items={items}
      columns={columns}
      {...props}
    />
  )
}
